// extracted by mini-css-extract-plugin
module.exports = {"titleFriends":"BlockFriends_titleFriends__3WWcC","friendBlock":"BlockFriends_friendBlock__3FLcD"};